export const AnswerRequiredType = {
  ALWAYS: 'ALWAYS',
  OPTIONAL: 'OPTIONAL',
  CONDITIONAL: 'CONDITIONAL',
} as const

export type AnswerRequiredType = (typeof AnswerRequiredType)[keyof typeof AnswerRequiredType]

export const ANSWER_REQUIRED_TYPE_LABELS: Record<AnswerRequiredType, string> = {
  ALWAYS: '必須',
  OPTIONAL: '任意',
  CONDITIONAL: '条件必須',
} as const

export const ANSWER_REQUIRED_TYPE_OPTIONS = Object.entries(ANSWER_REQUIRED_TYPE_LABELS).map(
  ([value, title]) => ({ value, title }),
) as { title: string, value: AnswerRequiredType }[]
